// extracted by mini-css-extract-plugin
export default {"home":"index_home__q9f2Q"};